import React, {Component} from 'react';
import _ from 'lodash';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import DocumentStore from '../../stores/DocumentStore';

export default class SearchDocumentForm extends Component {
  constructor() {
    super()

    var dateObj = new Date();
    var year = dateObj.getUTCFullYear();
    var current_year = year + 543;

    this.state = {
      start_year: current_year.toString(),
      end_year: current_year.toString(),
      start_date: '',
      end_date: '',
      document_template_id: '',
      receive_number: '',
      number: '',
      topic: '',
      reference: '',
      from_department: '',
      to_department: '',
      speed_level: '',
      secret_level: '',
      keywords: ''
    }

    this.onChange = this.onChange.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(){
    this.props.handleSubmit(this.state);
  }

  onChange(event){
    this.setState({
      [event.target.name]: event.target.value
    })
  }

  changeStartDate(date){
    this.setState({start_date: date});
  }

  changeEndDate(date){
    this.setState({end_date: date});
  }

  render(){
    const { 
      start_year, end_year, document_template_id, start_date, end_date, 
      receive_number, number, topic, reference, from_department, to_department,
      speed_level, secret_level, keywords
    } = this.state;

    return (
      <div>
        <div className='row pl-3'>
          <div className='col-xs-12'>
            <h3>ค้นหาทะเบียนหนังสือ</h3>
          </div>
        </div>

        <div className='card p-3 bg-light'>
          <div className='row'>

            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>จากปี</label>
              </div>
              <div>
                <select 
                  className='form-control form-control-sm'
                  name="start_year"
                  value={start_year}
                  onChange={this.onChange}>
                  <option value=''>- เลือก -</option>
                  {_.map(this.props.years, function(year, index){
                    return <option key={index} value={year}>{year}</option>
                  })}
                </select>
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>ถึงปี</label>
              </div>
              <div>
                <select 
                  className='form-control form-control-sm'
                  name="end_year"
                  value={end_year}
                  onChange={this.onChange}>
                  <option value=''>- เลือก -</option>
                  {_.map(this.props.years, function(year, index){
                    return <option key={index} value={year}>{year}</option>
                  })}
                </select>
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>ประเภทหนังสือ</label>
              </div>
              <div>
                <select 
                  className='form-control form-control-sm'
                  name='document_template_id'
                  value={document_template_id}
                  onChange={this.onChange}>
                  <option value=''>- เลือก -</option>
                  {_.map(this.props.document_template_types, function(document_template_type, index){
                    return <option key={index} value={document_template_type.id}>{document_template_type.label}</option>
                  })}
                </select>
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>จากวันที่</label>
              </div>
              <div>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  selected={start_date}
                  className='form-control form-control-sm'
                  placeholderText={'DD/MM/YYYY'}
                  onChange={this.changeStartDate} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>ถึงวันที่</label>
              </div>
              <div>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  selected={end_date}
                  className='form-control form-control-sm'
                  placeholderText={'DD/MM/YYYY'}
                  onChange={this.changeEndDate} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>เลขที่รับ</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='receive_number'
                  value={receive_number}
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>เลขที่หนังสือ</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='number'
                  value={number}
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>เรื่อง</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='topic'
                  value={topic}
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>อ้างถึง</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='reference'
                  value={reference}
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>จากหน่วยงาน</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='from_department'
                  value={from_department}
                  onChange={this.onChange } />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>หน่วยงานที่บันทึกรับ</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='to_department'
                  value={to_department}
                  onChange={this.onChange} />
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>ชั้นความเร็ว</label>
              </div>
              <div>
                <select 
                  className='form-control form-control-sm'
                  name='speed_level'
                  value={speed_level}
                  onChange={this.onChange}>
                  <option value=''>- เลือก -</option>
                  <option value='ปกติ'>ปกติ</option>
                  <option value='ด่วน'>ด่วน</option>
                  <option value='ด่วนมาก'>ด่วนมาก</option>
                  <option value='ด่วนที่สุด'>ด่วนที่สุด</option>
                </select>
              </div>
            </div>
            <div className='col-md-2 mb-2'>
              <div>
                <label className='label-control'>ชั้นความลับ</label>
              </div>
              <div>
                <select 
                  className='form-control form-control-sm'
                  name='secret_level'
                  value={secret_level}
                  onChange={this.onChange}>
                  <option value=''>- เลือก -</option>
                  <option value='ปกติ'>ปกติ</option>
                  <option value='ลับ'>ลับ</option>
                  <option value='ลับมาก'>ลับมาก</option>
                  <option value='ลับที่สุด'>ลับที่สุด</option>
                </select>
              </div>
            </div>
            <div className='col-md-2'>
              <div>
                <label className='label-control'>คำค้น</label>
              </div>
              <div>
                <input 
                  type='text' 
                  className='form-control form-control-sm'
                  name='keywords'
                  value={keywords}
                  onChange={this.onChange } />
              </div>
            </div>
            <div className='col-md-2 ml-auto text-right'>
              <div>
                <label className='label-control'></label>
              </div>
              <div>
                <button type='button' className='btn btn-primary btn-block' onClick={this.handleSubmit}>ค้นหา</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/documents/SearchDocumentForm.js